import { render, staticRenderFns } from "./Fullwidth.vue?vue&type=template&id=3b8c4b04"
import script from "./Fullwidth.vue?vue&type=script&lang=js"
export * from "./Fullwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports